import type { ScenarioModel } from '@/shared/generated'

import { Slot } from '@radix-ui/react-slot'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { useUpdateScenarioMutation } from '@/entities/scenario'

import { ampli } from '@/shared/lib/ampli'
import { useModals } from '@/shared/lib/modal-manager'
import { queryClient } from '@/shared/lib/query-client'

export function RenameScenario({
	children,
	scenario,
}: {
	scenario: ScenarioModel
	children: React.ReactNode
}) {
	const { t } = useTranslation()

	const { showModal } = useModals()
	const updateScenarioMutation = useUpdateScenarioMutation(scenario.id, {
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['scenarios'],
			})
			queryClient.invalidateQueries({
				queryKey: ['scenarios-query-list'],
			})
		},
	})
	const updateScenario = (name: string) => {
		ampli.whatIfScenarioRenameClicked()
		toast.promise(updateScenarioMutation.mutateAsync({ name }), {
			loading: t('saving.proccess', { defaultValue: 'Saving...' }),
			success: t('saving.success', { defaultValue: 'Saved successfully' }),
			error: t('saving.error', { defaultValue: 'Error while saving' }),
		})
	}
	const handleShowRenameModal = () =>
		showModal('GENERIC_RENAME_MODAL', {
			title: t('app.edit_scenario_name', {
				defaultValue: 'Edit scenario name',
			}),
			value: scenario.name,
			onChange: updateScenario,
		})

	return <Slot onClick={handleShowRenameModal}>{children}</Slot>
}
